import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

export default function BlockingHistory() {
  const [blockingHistory, setBlockingHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const ordersPerPage = 5;

  useEffect(() => {
    const fetchBlockingHistory = async () => {
      try {
        const response = await fetch(
          `/Acution/blocking-history?page=${currentPage}&limit=${ordersPerPage}`,
          {
            credentials: 'include',
          }
        );
        const data = await response.json();
        //console.log('Blocking history data:', data); // Debugging line to check data

        // 올바른 데이터 형식일 경우 상태 업데이트
        if (data && Array.isArray(data.history)) {
          setBlockingHistory(data.history);
          setTotalCount(data.totalCount);
        } else {
          console.error('Invalid data format:', data);
          setBlockingHistory([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.error('Error fetching blocking history:', error);
      }
    };

    fetchBlockingHistory();
  }, [currentPage]);

  const totalPages = Math.ceil(totalCount / ordersPerPage);

  return (
    <Container>
      <Title>블로킹 내역</Title>
      <OrderList>
        {blockingHistory.length > 0 ? (
          blockingHistory.map((block, index) => (
            <OrderItem key={index}>
              <OrderRow>
                <OrderLabel>블록일자:</OrderLabel>
                <OrderValue>{new Date(block.banned_at).toLocaleString()}</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>블록사유:</OrderLabel>
                <OrderValue>{block.ban_reason}</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>해제시간:</OrderLabel>
                <OrderValue>{block.unblock_time ? new Date(block.unblock_time).toLocaleString() : 'N/A'}</OrderValue>
              </OrderRow>
              <hr />
            </OrderItem>
          ))
        ) : (
          <p>블로킹 내역이 없습니다.</p>
        )}
      </OrderList>
      <Pagination>
        <PageButton
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          이전
        </PageButton>
        <PageNumber>
          페이지 {currentPage} / {totalPages}
        </PageNumber>
        <PageButton
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages || totalCount === 0}
        >
          다음
        </PageButton>
      </Pagination>
    </Container>
  );
}

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-radius: 10px;
`;

const Title = styled.h1`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
  font-size: 24px;
`;

const OrderList = styled.div`
  margin-top: 20px;
`;

const OrderItem = styled.div`
  padding: 15px;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
`;

const OrderRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

const OrderLabel = styled.span`
  font-weight: bold;
  color: #555;
`;

const OrderValue = styled.span`
  color: #333;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

const PageButton = styled.button`
  padding: 10px 15px;
  margin: 0 5px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: #0056b3;
  }
`;

const PageNumber = styled.span`
  margin: 0 10px;
  padding: 10px 0;
  font-size: 16px;
  color: #333;
`;
